import * as humbleLocalStorage from "humble-localstorage";
import * as moment from "moment";
import * as Cookies from "universal-cookie";

import { IToken } from "@nkr/models/index";

export class AuthorizationService {
    public lock: any;

    constructor(clientId: any, domain: any) { }

    public static isLoggedIn() {
        //   Checks if there is a saved token and it's still valid
        const token: IToken | null = AuthorizationService.getToken();
        return !!token && !AuthorizationService.isTokenExpired();
    }

    public static logout() {
        var cookies = new Cookies();

        cookies.remove("NkrSession", { path: "/", domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });
        cookies.remove("NkrAuth", { path: "/", domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });
    }

    public static setToken(idToken: IToken) {
    }

    public static getToken(): IToken | null {
        return null;
    }

    public static getTokenExpirationDate() {
        const token: IToken | null = AuthorizationService.getToken();

        if (token != null) {
            if (!token.expires) {
                return { valid: false };
            }

            return { valid: true, date: token.expires }
        } else {
            return { valid: false };
        }
    }

    public static isTokenExpired() {
        const token: IToken | null = AuthorizationService.getToken();

        if (!token) {
            return true;
        }

        var tokenDateInfo: any = AuthorizationService.getTokenExpirationDate();

        if (!tokenDateInfo.valid)
            return false;
        else {
            var expires = moment(tokenDateInfo.date);
            var now = moment.utc();
            var minutes = expires.diff(now, 'minutes')

            return (minutes == 0);
        }
    }
}